<template>
  <v-layout row wrap my-3 mx-2>
    <v-flex xs12 md6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Post To Instagram
        </v-card-title>
        <v-layout row wrap px-2 pt-3>
          <v-flex class="text-xs-center" xs12 py-3>
            <croppa 
              class="elevation-6"
              v-model="croppa"
              accept=".jpg,.png"
              :width="306"
              :height="306"
              :show-loading="true"
              :show-remove-button="true"
              :disable-rotation="true"
              :prevent-white-space="true"
              :zoom-speed="10"
              initial-size="cover"
              initial-position="center"
              @new-image-drawn="download"
              @move="download"
              @zoom="download"
              @image-remove="handleImageRemove"
            >
            </croppa>
          </v-flex>
          <v-flex xs12 md6 px-1>
            <v-text-field
              label="Username"
              v-model="username"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 px-1>
            <v-text-field
              label="Password"
              v-model="password"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-textarea
              label="Caption"
              v-model="caption"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="postToAPI()" :loading="loading" color="primary" dark>Post</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Preview
        </v-card-title>
        <v-layout row wrap px-2 pt-3>
          <v-flex xs12 class="text-xs-center">
            <IG 
            :img="postImage"
            :username="username"
            :caption="caption"
            :loading="loading"
            :upload="upload"
            />
          </v-flex>
          <v-flex xs1>
            
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate'
import { required, url } from 'vuelidate/lib/validators'
import { storageRef, firebase, db, auth } from '@/fb';
import IG from './instagramPostTemplate'
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';

export default {
  mixins: [validationMixin],
  components:{IG},
  data() {
    return {
      loading:false,
      success:null,
      error:null,
      errors:[],
      croppa:{},
      username:null,
      password:null,
      postImage:null,
      caption:null,
      upload:0,
    }
  },
  methods: {
    postToAPI(){
      this.loading = true
      let post = {
        username:this.username,
        password:this.password,
        img:this.postImage,
        caption:this.caption
      }
      var headers = {
        'Accept': 'application/json'
      }
      axios.post('//autogram.4w7pc5z8gc.com/singlePost.php', post, {headers: headers})
      .then(resp=>{
        console.log(resp.data)
        this.loading = false
      })
    },
    download(type, compressionRate) {
      this.loading = true
      this.croppa.generateBlob((blob) => {
        var file = blob
        var metadata = {
          contentType: 'image/jpeg'
        };
        var uploadTask = storageRef.child('instagram/' + this.username +'-' + randomString(8, 'aA#') + '.jpg').put(file, metadata);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          (snapshot)=> {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.upload = progress
                  }, (error) =>{
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        },() => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
            this.postImage = (downloadURL)
            this.loading = false
          });
        });
      }, type, compressionRate)
    },
    goTo(path) {
      this.$router.push(path)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    handleImageRemove(){
      this.postImage = null
    }
  },
  watch:{
    
  },
  computed:{
    
  },
  validations: {
    
  }
}
</script>

<style scoped>

</style>

